import { Helmet } from "react-helmet";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Navigation from "./components/navigation";
import { useAuth } from "./hooks/useAuth";

import Home from "./pages/Home";
import Data from "./pages/Data";
import Login from "./pages/Login";
import Units from "./pages/Units";
import Users from "./pages/Users";
import OAuthPage from "./pages/OAuthPage";

const App = () => {
  const { isLogged } = useAuth();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <div
        className="App"
        style={{
          background: "linear-gradient(45deg, #162B56, #000000)",
          overflow: "hidden",
        }}
      >
        <Helmet>
          <meta charSet="utf-8" />
          <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
          />
          <title>MedicAir Data - Dashboard</title>
        </Helmet>
          <BrowserRouter>
          <Navigation />
            <Routes>
              {isLogged ?
              <>
                <Route path="/" element={<Home />} />
                <Route path="/data/pm25" element={<Data pageTitle="PM2.5" sensorType="pm25" />} />
                <Route path="/data/co2" element={<Data pageTitle="CO2" sensorType="co2" />} />
                <Route path="/data/temp" element={<Data pageTitle="Temperature" sensorType="temp" />} />
                <Route path="/data/humidity" element={<Data pageTitle="Humidity" sensorType="humidity" />} />
                <Route path="/units" element={<Units />} />
                <Route path="/users" element={<Users />} />
              </> :
              <>
                <Route path="/oauth/:clientType" element={<OAuthPage />} />
                <Route path="/*" element={<Login />} />
              </>
              }
            </Routes>
          </BrowserRouter>
      </div>
    </LocalizationProvider>
  );
};

export default App;
